import React, { Component, Fragment } from 'react';
import { Platform, Dimensions } from 'react-native';
import { View } from 'react-native';
import { Offline } from 'react-detect-offline';
import { connect } from 'react-redux';

import Text from '../../react-component/textComponent';

import styles, { WarningConnection, StyledIcon } from './styles';

const { width } = Dimensions.get('window'),
    isDesktop = Platform.OS === 'web' && width > 720;

class DetectConnection extends Component {
    reloadPage = () => {
        window.location.reload();
    };

    renderContent = () => {
        return (
            <View
                style={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'none',
                    backgroundColor: 'yellow'
                }}
            >
                <WarningConnection
                    style={{
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    onPress={this.reloadPage}
                >
                    <Text style={styles.text}>
                        Conexão perdida, clique aqui para recarregar!
                        <View style={styles.icon}>
                            <StyledIcon
                                sx={{
                                    fontSize: isDesktop ? 18 : 14
                                }}
                            />
                        </View>
                    </Text>
                </WarningConnection>
            </View>
        );
    };

    render() {
        const { websocketConnection = true } = this.props;

        const isConnected = websocketConnection;
        const offlineProps = { url: window.location.href };
        return (
            <Fragment>
                {isConnected ? (
                    <Offline polling={offlineProps}>
                        {this.renderContent()}
                    </Offline>
                ) : (
                    <Fragment>{this.renderContent()}</Fragment>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = ({ websocketConnection }) => ({
    websocketConnection
});

export default connect(mapStateToProps, null)(DetectConnection);
